export default __webpack_public_path__ + "static/post-finance-7a5395eb6bd18b764ee4b6b69d687feb.svg";